<template>
  <base-icon class="save-spinner" icon-name="loader" />
</template>

<script>
  export default{
    name: 'spinner'
  }
</script>

<style>
  .save-spinner {
    display: inline-block;
    vertical-align: middle;
    top: -1px;
    animation-name: spin;
    animation-duration: 1600ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  /* Safari */
  @-webkit-keyframes spin {
    from { -webkit-transform: rotate(360deg); }
    to { -webkit-transform: rotate(0deg); }
  }
  @keyframes spin {
    from { transform:rotate(360deg); }
    to { transform:rotate(0deg); }
  }
</style>
